import {
  createAuthBackend,
  loadAuthBackend,
  loadActiveAuthBackend,
  updateAuthBackend,
  deleteAuthBackend,
  testAuthConnection,
  testAuthLogin,
  setActiveAuthBackend,
  loadAuthBackendsPaginated,
  loadAuthBackendUsersPaginated,
  loadActiveAuthBackendType
} from "hooks/useAuthentication";
import notifyingAction from "../notifyingAction";
const create = notifyingAction({
  action: createAuthBackend,
  success: (authBackend) => ({
    message: `Authentication service "${authBackend.title} was created successfully`
  }),
  error: (error, authBackend) => ({
    message: `Creating authentication service "${authBackend.title}" failed with status: ${error}`
  })
});
const load = notifyingAction({
  action: loadAuthBackend,
  error: (error, authBackendId) => ({
    message: `Loading authentication service with id "${authBackendId}" failed with status: ${error}`
  }),
  notFoundRedirect: true
});
const loadActive = notifyingAction({
  action: loadActiveAuthBackend,
  error: (error) => ({
    message: `Loading active authentication service failed with status: ${error}`
  })
});
const update = notifyingAction({
  action: updateAuthBackend,
  success: (_authBackendId, authBackend) => ({
    message: `Authentication service "${authBackend.title}" was updated successfully`
  }),
  error: (error, _authBackendId, authBackend) => ({
    message: `Updating authentication service "${authBackend.title}" failed with status: ${error}`
  })
});
const deleteBackend = notifyingAction({
  action: (backendId, _authBackendTitle) => deleteAuthBackend(backendId),
  success: (_authBackendId, authBackendTitle) => ({
    message: `Authentication service "${authBackendTitle} was deleted successfully`
  }),
  error: (error, _authBackendId, authBackendTitle) => ({
    message: `Deleting authentication service "${authBackendTitle}" failed with status: ${error}`
  })
});
const testConnection = notifyingAction({
  action: testAuthConnection,
  error: (error) => ({
    message: `Connection test failed with status: ${error}`
  })
});
const testLogin = notifyingAction({
  action: testAuthLogin,
  error: (error) => ({
    message: `Login test failed with status: ${error}`
  })
});
const setActiveBackend = notifyingAction({
  action: (backendId, _authBackendTitle) => setActiveAuthBackend(backendId),
  success: (authBackendId, authBackendTitle) => ({
    message: `Authentication service "${authBackendTitle} was ${authBackendId ? "activated" : "deactivated"} successfully`
  }),
  error: (error, _authBackendId, authBackendTitle) => ({
    message: `Activating authentication service "${authBackendTitle}" failed with status: ${error}`
  })
});
const loadBackendsPaginated = notifyingAction({
  action: loadAuthBackendsPaginated,
  error: (error) => ({
    message: `Loading authentication services failed with status: ${error}`
  })
});
const loadUsersPaginated = notifyingAction({
  action: loadAuthBackendUsersPaginated,
  error: (authBackendId, error) => ({
    message: `Loading synchronized users for authentication service with id "${authBackendId}" failed with status: ${error}`
  })
});
const loadActiveBackendType = notifyingAction({
  action: loadActiveAuthBackendType,
  error: (error) => ({
    message: `Loading active authentication service type failed with status: ${error}`
  })
});
export default {
  create,
  update,
  load,
  loadActive,
  delete: deleteBackend,
  testConnection,
  testLogin,
  setActiveBackend,
  loadBackendsPaginated,
  loadUsersPaginated,
  loadActiveBackendType
};
